import React from "react";
import { useSelector } from "react-redux";
import AreaChart from "../../../../components/areaChart/areaChart";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { PeriodType } from "./periodType";

function detectInterval(data) {
  let interval = "preserveEnd";
  const length = data.length;
  data.map((item) => {
    if (item.name.indexOf(" - ") > -1) {
      if (data.length === 9) {
        return "preserveStartEnd";
      } else {
        interval = Math.floor(length * 0.15);
      }
    }
  });
  return interval;
}

export const YearOverYear = () => {
  const chartData = useSelector((state) => state.utilization.graphData.chart_values);
  const interval = detectInterval(chartData);
  const currencySymbol = useSelector((state) => state.utilization.chartCurrencySymbol);
  const currentSelectedCategory = useSelector((state) => state.utilization.currentSelectedCategory);
  const toolTipContent = useSelector((state) => state.utilization.averageTooltip);
  const yearOverYearLoading = useSelector((state) => state.utilization.yearOverYearLoading);

  return (
    <>
      <div className="chart-header">
        <h2>Total {currentSelectedCategory} Breakdown</h2>
        <div className="select-box" style={{ width: "200px" }}>
          {yearOverYearLoading ? (
            <button className="picky__input">
              <LoadingAnimation uiLoader />{" "}
            </button>
          ) : (
            <PeriodType />
          )}
        </div>
      </div>
      <AreaChart
        chartData={chartData}
        interval={interval}
        right={80}
        left={80}
        width={1350}
        currencySymbol={currencySymbol}
        hasRawData
        showDecimals
        hideLegend
        tooltipName={currentSelectedCategory}
        toolTipContent={!!toolTipContent}
      />
    </>
  );
};
